module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_ERROR_MESSAGES", function() { return DEFAULT_ERROR_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTE_IGNORE_INTERCEPT", function() { return ATTRIBUTE_IGNORE_INTERCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOG_MSG_PREFIX", function() { return LOG_MSG_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTER_REDUCER_KEY", function() { return ROUTER_REDUCER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OS_MAC", function() { return OS_MAC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OS_WIN", function() { return OS_WIN; });
var DEFAULT_ERROR_MESSAGES /* : Object */ = {
  '404': 'Route Not Found',
  '401': 'Route Not Authorized (loginRequired)',
  '403': 'Route Forbidden (logoutRequired)',
  '500': 'Unhandled Exception'
};

var ATTRIBUTE_IGNORE_INTERCEPT /* : string */ = 'data-ignore-intercept';
var LOG_MSG_PREFIX /* : string */ = '[Router]';
var ROUTER_REDUCER_KEY /* : string */ = 'router';

var OS_MAC /* : string */ = 'MAC';
var OS_WIN /* : string */ = 'WIN';

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunc", function() { return isFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouteChangeOptionsBefore", function() { return applyRouteChangeOptionsBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouteChangeOptionsAfter", function() { return applyRouteChangeOptionsAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouteChangeOptionsAll", function() { return applyRouteChangeOptionsAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildFullPath", function() { return buildFullPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildQueryStr", function() { return buildQueryStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildQueryObj", function() { return buildQueryObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasObjectChanged", function() { return hasObjectChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildErrorMetadata", function() { return buildErrorMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tranformRoutesDefinitionToComponentMapping", function() { return tranformRoutesDefinitionToComponentMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineParamsQuery", function() { return combineParamsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pathToRegExp", function() { return pathToRegExp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



var isArray = function isArray(test) {
  return test && test.constructor === Array;
};
var isObject = function isObject(test) {
  return test && test.constructor === Object;
};
var isString = function isString(test) {
  return typeof test === 'string';
};
var isFunc = function isFunc(test) {
  return typeof test === 'function';
};

// Options applied to view/params/query before determining the next route
var applyRouteChangeOptionsBefore = function applyRouteChangeOptionsBefore(view) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var currentRoute = arguments[4];

  var nextView = typeof view === 'string' ? view : currentRoute.view;

  if (!options.inherit) {
    return {
      nextView: nextView,
      nextParams: params,
      nextQuery: query
    };
  } else if (typeof options.inherit === 'boolean') {
    return {
      nextView: nextView,
      nextParams: combineParamsQuery(params, currentRoute.params),
      nextQuery: combineParamsQuery(query, currentRoute.query)
    };
  } else {
    var inherit = options.inherit;

    return {
      nextView: nextView,
      nextParams: inherit.params ? combineParamsQuery(params, currentRoute.params) : params,
      nextQuery: inherit.query ? combineParamsQuery(query, currentRoute.query) : query
    };
  }
};

// Options applied to view/params/query after determining the next route and applying the querySelector
var applyRouteChangeOptionsAfter = function applyRouteChangeOptionsAfter(view, params, query, options, currentRoute) {
  var routeDefQuery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  var finalView = view || currentRoute.view;
  var finalParams = params;
  var finalQuery = _extends({}, query);

  for (var q in routeDefQuery) {
    if (!finalQuery.hasOwnProperty(q)) {
      finalQuery[q] = routeDefQuery[q];
    }
  }
  return {
    finalView: finalView,
    finalParams: finalParams,
    finalQuery: finalQuery
  };
};

var applyRouteChangeOptionsAll = function applyRouteChangeOptionsAll(view, params, query, options, currentRoute) {
  var _applyRouteChangeOpti = applyRouteChangeOptionsBefore(view, params, query, options, currentRoute),
      nextView = _applyRouteChangeOpti.nextView,
      nextParams = _applyRouteChangeOpti.nextParams,
      nextQuery = _applyRouteChangeOpti.nextQuery;

  var _applyRouteChangeOpti2 = applyRouteChangeOptionsAfter(nextView, nextParams, nextQuery, options, currentRoute),
      finalView = _applyRouteChangeOpti2.finalView,
      finalParams = _applyRouteChangeOpti2.finalParams,
      finalQuery = _applyRouteChangeOpti2.finalQuery;
  // Return as nextView... because they may be modified by the querySelector on the new route when called from this method


  return {
    nextView: finalView,
    nextParams: finalParams,
    nextQuery: finalQuery
  };
};

var buildFullPath = function buildFullPath(routeDef, params, query, options) {
  var path = routeDef.path;

  var paramNames = Object.keys(params);

  // Replace the url parameters with values
  var fullPath = path;
  paramNames.forEach(function (paramName) {
    fullPath = fullPath.replace(':' + paramName + '?', encodeURIComponent(params[paramName]));
    fullPath = fullPath.replace(':' + paramName, encodeURIComponent(params[paramName]));
  });

  // Remove unused optional paramters from url
  fullPath = fullPath.replace(/(:[^/]+\?)/g, '');
  // Remove trailing slashes
  fullPath = fullPath !== '/' ? fullPath.replace(/\/+$/, '') : fullPath;

  fullPath += buildQueryStr(routeDef.query, query);

  return fullPath;
};

var buildQueryStr = function buildQueryStr() {
  var queryDef = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var queryVals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var filtered = {};
  var hasValidValues = false;
  queryDef.forEach(function (name) {
    if (queryVals.hasOwnProperty(name) && queryVals[name] !== undefined) {
      filtered[name] = queryVals[name];
      hasValidValues = true;
    }
  });
  return hasValidValues ? '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(filtered) : '';
};

var buildQueryObj = function buildQueryObj() {
  var query = {};
  if (window.location.search) {
    query = _extends({}, __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search));
  }
  return query;
};

var hasObjectChanged = function hasObjectChanged(current, previous) {
  // Returns true if an object has changed. Does not work for nested objects
  if (!!current !== !!previous || Object.keys(current).length !== Object.keys(previous).length) {
    return true;
  }
  // Check values
  var prevDiff = _extends({}, previous);
  for (var key in current) {
    if (current[key] !== previous[key]) {
      return true;
    }
    delete prevDiff[key];
  }
  if (Object.keys(prevDiff).length) {
    return true;
  }
  return false;
};

var buildErrorMetadata = function buildErrorMetadata(routeObj) {
  return { location: window.location.href, routeObj: routeObj };
};

var tranformRoutesDefinitionToComponentMapping = function tranformRoutesDefinitionToComponentMapping(ROUTES) {
  return Object.keys(ROUTES).reduce(function (views, viewId) {
    views[viewId] = ROUTES[viewId].component;
    return views;
  }, {});
};

var combineParamsQuery = function combineParamsQuery() {
  var newObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _extends({}, currentObj, newObj);
  // for (let key in newObj) {
  //   if (['', null, undefined].indexOf(newObj[key]) > -1 && combined.hasOwnProperty(key)) {
  //     delete combined[key];
  //   } else {
  //     combined[key] = newObj[key];
  //   }
  // }
  // return combined;
};

/*eslint-disable */
// Used by ruta3: https://github.com/bevacqua/ruta3/blob/master/pathToRegExp.js
var pathToRegExp = function pathToRegExp(path, keys) {
  path = path.concat('/?').replace(/\/\(/g, '(?:/').replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?|\*/g, tweak).replace(/([\/.])/g, '\\$1').replace(/\*/g, '(.*)');

  return new RegExp('^' + path + '$', 'i');

  function tweak(match, slash, format, key, capture, optional) {
    if (match === '*') {
      keys.push(void 0);
      return match;
    }

    keys.push(key);

    slash = slash || '';

    return '' + (optional ? '' : slash) + '(?:' + (optional ? slash : '') + (format || '') + (capture ? capture.replace(/\*/g, '{0,}').replace(/\./g, '[\\s\\S]') : '([^/]+?)') + ')' + (optional || '');
  }
};
/*eslint-enable */

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRouterState", function() { return getRouterState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentRoute", function() { return getCurrentRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentView", function() { return getCurrentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentParams", function() { return getCurrentParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentQuery", function() { return getCurrentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousRoute", function() { return getPreviousRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousView", function() { return getPreviousView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousParams", function() { return getPreviousParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousQuery", function() { return getPreviousQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsRouterReady", function() { return getIsRouterReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsSagaRunning", function() { return getIsSagaRunning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckpoints", function() { return getCheckpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCheckpointById", function() { return getCheckpointById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRouteChangeSummary", function() { return getRouteChangeSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);





var getRouterState = function getRouterState(state) {
  return state[__WEBPACK_IMPORTED_MODULE_1__constants__["ROUTER_REDUCER_KEY"]];
};

var getCurrentRoute = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
  return routerState.current;
});

var getCurrentView = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCurrentRoute, function (routeDef) {
  return routeDef.view;
});

var getCurrentParams = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCurrentRoute, function (routeDef) {
  return routeDef.params;
});

var getCurrentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCurrentRoute, function (routeDef) {
  return routeDef.query;
});

var getPreviousRoute = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
  return routerState.previous;
});

var getPreviousView = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getPreviousRoute, function (routeDef) {
  return routeDef.view;
});

var getPreviousParams = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getPreviousRoute, function (routeDef) {
  return routeDef.params;
});

var getPreviousQuery = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getPreviousRoute, function (routeDef) {
  return routeDef.query;
});

var getIsRouterReady = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
  return routerState.ready;
});

var getIsSagaRunning = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
  return routerState.sagaRunning;
});

var getCheckpoints = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
  return routerState.checkpoints;
});

var getCheckpointById = function getCheckpointById(checkpoint) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getRouterState, function (routerState) {
    return routerState.checkpoints[checkpoint];
  });
};

var getRouteChangeSummary = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(getCurrentRoute, getPreviousRoute, function (current, previous) {
  var viewChanged = current.view !== previous.view;
  return {
    changes: {
      // Booleans indicating which part has changed
      view: viewChanged,
      params: viewChanged ? false : Object(__WEBPACK_IMPORTED_MODULE_2__utils__["hasObjectChanged"])(current.params, previous.params),
      query: viewChanged ? false : Object(__WEBPACK_IMPORTED_MODULE_2__utils__["hasObjectChanged"])(current.query, previous.query)
    },
    current: current,
    previous: previous
  };
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(5);
var objectAssign = __webpack_require__(6);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMemoize */
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ })
/******/ ]);
//# sourceMappingURL=selectors.js.map